/**
 * @generated SignedSource<<56fbcd57df3d5a90b741a5b41db1cb12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BackgroundThemeEnum = "default" | "light";
export type SlugViewer_Query$variables = {
  ref?: string | null | undefined;
  referrer?: string | null | undefined;
  requestValid: boolean;
  slug: string;
  subslug?: string | null | undefined;
  token?: string | null | undefined;
};
export type SlugViewer_Query$data = {
  readonly currentUser: {
    readonly " $fragmentSpreads": FragmentRefs<"Job_User" | "JobsListing_User">;
  } | null | undefined;
  readonly resource?: {
    readonly __typename: "Firm";
    readonly " $fragmentSpreads": FragmentRefs<"JobsListing_Firm">;
  } | {
    readonly __typename: "Job";
    readonly firm: {
      readonly backgroundTheme: BackgroundThemeEnum | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"Job_Job">;
  } | {
    readonly __typename: "User";
    readonly " $fragmentSpreads": FragmentRefs<"FreelancerProfile_UserScene">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type SlugViewer_Query = {
  response: SlugViewer_Query$data;
  variables: SlugViewer_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ref"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "referrer"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requestValid"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "subslug"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v6 = [
  {
    "kind": "Variable",
    "name": "ref",
    "variableName": "ref"
  },
  {
    "kind": "Variable",
    "name": "referrer",
    "variableName": "referrer"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  },
  {
    "kind": "Variable",
    "name": "subslug",
    "variableName": "subslug"
  },
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backgroundTheme",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "self",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = [
  (v12/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v18 = [
  (v17/*: any*/),
  (v12/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Contract",
  "kind": "LinkedField",
  "name": "contract",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availabilityType",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionTypes",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rateMode",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Currency",
  "kind": "LinkedField",
  "name": "currency",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v26 = [
  (v25/*: any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "minFreelancerRate",
  "plural": false,
  "selections": (v26/*: any*/),
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "freelancerRate",
  "plural": false,
  "selections": (v26/*: any*/),
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullAddress",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "region",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationLatitude",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationLongitude",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "minClientRate",
  "plural": false,
  "selections": (v26/*: any*/),
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "clientRate",
  "plural": false,
  "selections": (v26/*: any*/),
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "margin",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minMarginUsd",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "Referral",
  "kind": "LinkedField",
  "name": "referralFromSelf",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    },
    (v12/*: any*/)
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v40 = [
  (v39/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupIndex",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiredYears",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "required",
  "storageKey": null
},
v44 = [
  (v12/*: any*/),
  (v11/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "Skill",
  "kind": "LinkedField",
  "name": "skill",
  "plural": false,
  "selections": (v44/*: any*/),
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "experience",
  "storageKey": null
},
v47 = [
  (v7/*: any*/),
  (v12/*: any*/)
],
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roles",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SlugViewer_Query",
    "selections": [
      {
        "condition": "requestValid",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "resource",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Job_Job"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Firm",
                    "kind": "LinkedField",
                    "name": "firm",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Job",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "JobsListing_Firm"
                  }
                ],
                "type": "Firm",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FreelancerProfile_UserScene"
                  }
                ],
                "type": "User",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Job_User"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "JobsListing_User"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "SlugViewer_Query",
    "selections": [
      {
        "condition": "requestValid",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "resource",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Firm",
                    "kind": "LinkedField",
                    "name": "firm",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "website",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      (v8/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Contract",
                        "kind": "LinkedField",
                        "name": "contract",
                        "plural": false,
                        "selections": (v16/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "country",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "locationType",
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "incognito",
                    "storageKey": null
                  },
                  {
                    "alias": "jobStatus",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobApplication",
                    "kind": "LinkedField",
                    "name": "jobApplication",
                    "plural": false,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableAutomatedMessaging",
                    "storageKey": null
                  },
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "officePolicy",
                    "storageKey": null
                  },
                  (v38/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "descriptionExperience",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "descriptionResponsibilities",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v40/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Industry",
                    "kind": "LinkedField",
                    "name": "industry",
                    "plural": false,
                    "selections": [
                      (v39/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobsSpecialization",
                    "kind": "LinkedField",
                    "name": "jobsSpecializations",
                    "plural": true,
                    "selections": [
                      (v41/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Specialization",
                        "kind": "LinkedField",
                        "name": "specialization",
                        "plural": false,
                        "selections": (v40/*: any*/),
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobSkill",
                    "kind": "LinkedField",
                    "name": "jobSkills",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v41/*: any*/),
                      (v45/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requiredExperienceYears",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectLengthInMonths",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Country",
                    "kind": "LinkedField",
                    "name": "jobCountries",
                    "plural": true,
                    "selections": [
                      (v23/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timezoneIdentifier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timezoneRange",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timezoneUtcOffset",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "defaultDistance",
                    "storageKey": null
                  }
                ],
                "type": "Job",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v12/*: any*/),
                  (v14/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v15/*: any*/),
                  (v9/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Video",
                    "kind": "LinkedField",
                    "name": "video",
                    "plural": false,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filters",
                        "value": {
                          "status": "opened"
                        }
                      },
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 20
                      }
                    ],
                    "concreteType": "JobConnection",
                    "kind": "LinkedField",
                    "name": "jobs",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "JobEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Job",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v10/*: any*/),
                              (v9/*: any*/),
                              (v15/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v35/*: any*/),
                              (v34/*: any*/),
                              (v28/*: any*/),
                              (v27/*: any*/),
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Firm",
                                "kind": "LinkedField",
                                "name": "firm",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "JobSkill",
                                "kind": "LinkedField",
                                "name": "jobSkills",
                                "plural": true,
                                "selections": [
                                  (v43/*: any*/),
                                  (v42/*: any*/),
                                  (v41/*: any*/),
                                  (v45/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserSkill",
                                    "kind": "LinkedField",
                                    "name": "userSkill",
                                    "plural": false,
                                    "selections": [
                                      (v46/*: any*/),
                                      (v12/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "JobApplication",
                                "kind": "LinkedField",
                                "name": "jobApplication",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v17/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContractRequest",
                                    "kind": "LinkedField",
                                    "name": "contractRequests",
                                    "plural": true,
                                    "selections": (v47/*: any*/),
                                    "storageKey": null
                                  },
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Interview",
                                    "kind": "LinkedField",
                                    "name": "latestInterview",
                                    "plural": false,
                                    "selections": (v47/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v36/*: any*/),
                              (v37/*: any*/),
                              (v38/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "jobs(filters:{\"status\":\"opened\"},first:20)"
                  }
                ],
                "type": "Firm",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v12/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "avatarUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Industry",
                        "kind": "LinkedField",
                        "name": "industry",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "profilesRequireSkills",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v29/*: any*/),
                      (v31/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Country",
                        "kind": "LinkedField",
                        "name": "country",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v30/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "zip",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "textIntroduction",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "openToOpportunities",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Specialization",
                        "kind": "LinkedField",
                        "name": "specializations",
                        "plural": true,
                        "selections": (v44/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locationBounds0",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locationBounds1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locationBounds2",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locationBounds3",
                        "storageKey": null
                      },
                      (v32/*: any*/),
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlBlog",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlDribbble",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlGithub",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlLinkedin",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "availability",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canWorkInTheUs",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "managedTeamSize",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "availableAt",
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Money",
                        "kind": "LinkedField",
                        "name": "freelancerRate",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v24/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v35/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "jobTypes",
                        "storageKey": null
                      },
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalExperience",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Video",
                    "kind": "LinkedField",
                    "name": "video",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "posterUrl",
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Resume",
                    "kind": "LinkedField",
                    "name": "resume",
                    "plural": false,
                    "selections": [
                      (v48/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "backgroundCheckCompleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timezone",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimelineEntry",
                    "kind": "LinkedField",
                    "name": "timelineEntries",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "entryType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "place",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateStart",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateEnd",
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Institute",
                        "kind": "LinkedField",
                        "name": "institute",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "worldRankRange",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rankingYear",
                            "storageKey": null
                          },
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Company",
                        "kind": "LinkedField",
                        "name": "company",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "custom",
                            "storageKey": null
                          },
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Skill",
                        "kind": "LinkedField",
                        "name": "skills",
                        "plural": true,
                        "selections": (v44/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserSkill",
                    "kind": "LinkedField",
                    "name": "userSkills",
                    "plural": true,
                    "selections": [
                      (v46/*: any*/),
                      (v45/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Video",
                    "kind": "LinkedField",
                    "name": "answers",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v48/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "public",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Question",
                        "kind": "LinkedField",
                        "name": "question",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          (v10/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "User",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v16/*: any*/),
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workingOrOfferedJob",
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "realUser",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v49/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMember",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "guest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isClient",
            "storageKey": null
          },
          (v49/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Configuration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enableCompanyVideos",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ca3a51fb69ed953659ff9beb2f3aed9e",
    "id": null,
    "metadata": {},
    "name": "SlugViewer_Query",
    "operationKind": "query",
    "text": "query SlugViewer_Query(\n  $slug: String!\n  $subslug: String\n  $token: String\n  $ref: String\n  $referrer: String\n  $requestValid: Boolean!\n) {\n  resource(slug: $slug, subslug: $subslug, token: $token, ref: $ref, referrer: $referrer) @include(if: $requestValid) {\n    __typename\n    ... on Job {\n      ...Job_Job\n      firm {\n        backgroundTheme\n        id\n      }\n    }\n    ... on Firm {\n      ...JobsListing_Firm\n    }\n    ... on User {\n      ...FreelancerProfile_UserScene\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  currentUser {\n    ...Job_User\n    ...JobsListing_User\n    id\n  }\n}\n\nfragment ApplicationStatusTextTag_JobApplication on JobApplication {\n  status\n}\n\nfragment ApplicationStepsButton_JobApplication on JobApplication {\n  status\n  contractRequests {\n    __typename\n    id\n  }\n  contract {\n    status\n    id\n  }\n  latestInterview {\n    __typename\n    id\n  }\n}\n\nfragment AvailabilityAndPositionTypeFields_User on User {\n  ...AvailabilityEditDialog_User\n  ...AvailabilityBadge_User\n}\n\nfragment AvailabilityBadge_User on User {\n  profile {\n    availability\n    availabilityType\n    availableAt\n    id\n  }\n  timezone\n}\n\nfragment AvailabilityEditDialog_User on User {\n  profile {\n    availability\n    availableAt\n    availabilityType\n    id\n  }\n}\n\nfragment AvatarField_User on User {\n  avatarUrl\n}\n\nfragment BadgesArea_User on User {\n  backgroundCheckCompleted\n  status\n  profile {\n    availability\n    canWorkInTheUs\n    managedTeamSize\n    id\n  }\n  ...AvailabilityAndPositionTypeFields_User\n  ...StatusField_User\n  ...TeamManagementField_User\n  ...USWorkField_User\n}\n\nfragment CompensationSummary_User on User {\n  self\n  profile {\n    currency {\n      code\n      id\n    }\n    freelancerRate {\n      value\n    }\n    clientRate {\n      value\n    }\n    jobTypes\n    rateMode\n    id\n  }\n}\n\nfragment ExperienceSummary_User on User {\n  profile {\n    totalExperience\n    id\n  }\n}\n\nfragment FreelancerProfileHead_User on User {\n  firstName\n  lastName\n  avatarUrl\n  email\n  profile {\n    slug\n    industry {\n      name\n      id\n    }\n    fullAddress\n    region\n    country {\n      name\n      id\n    }\n    city\n    zip\n    textIntroduction\n    id\n  }\n  video {\n    posterUrl\n    id\n  }\n}\n\nfragment FreelancerProfile_User on User {\n  id\n  self\n  status\n  profile {\n    openToOpportunities\n    id\n  }\n  ...Summary_UserProfile\n  ...TimelineEntriesField_User\n  ...UserSkillsFields_User\n  ...VideoField_User\n  ...VideoAnswersField_User\n}\n\nfragment FreelancerProfile_UserScene on User {\n  id\n  self\n  ...FreelancerProfileHead_User\n  ...FreelancerProfile_User\n}\n\nfragment IndustryField_User on User {\n  profile {\n    industry {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment JobClientActions_Job on Job {\n  slug\n  firm {\n    slug\n    self\n    id\n  }\n}\n\nfragment JobClientActions_User on User {\n  ...user_useIsClient\n  ...user_useIsRecruiterOrAdmin\n  ...user_useIsRealAdmin\n}\n\nfragment JobFooter_Job on Job {\n  incognito\n  firm {\n    slug\n    name\n    id\n  }\n  jobApplication {\n    ...JobFooter_JobApplication\n    id\n  }\n}\n\nfragment JobFooter_JobApplication on JobApplication {\n  status\n}\n\nfragment JobFooter_User on User {\n  status\n  ...user_useIsClient\n}\n\nfragment JobFormWrapper_Job on Job {\n  slug\n  firm {\n    slug\n    id\n    name\n    description\n    website\n  }\n  title\n  description\n  descriptionExperience\n  descriptionResponsibilities\n  user {\n    rawId\n    name\n    id\n  }\n  industry {\n    rawId\n    id\n  }\n  jobsSpecializations {\n    groupIndex\n    specialization {\n      rawId\n      name\n      id\n    }\n    id\n  }\n  jobSkills {\n    id\n    requiredYears\n    required\n    groupIndex\n    skill {\n      id\n      name\n    }\n  }\n  positionTypes\n  freelancerRate {\n    value\n  }\n  minFreelancerRate {\n    value\n  }\n  clientRate {\n    value\n  }\n  minClientRate {\n    value\n  }\n  currency {\n    code\n    id\n  }\n  requiredExperienceYears\n  rateMode\n  projectLengthInMonths\n  locationType\n  jobCountries {\n    code\n    name\n    id\n  }\n  timezoneIdentifier\n  timezoneRange\n  timezoneUtcOffset\n  fullAddress\n  country\n  region\n  city\n  locationLatitude\n  locationLongitude\n  defaultDistance\n}\n\nfragment JobHead_Job on Job {\n  slug\n  title\n  availabilityType\n  positionTypes\n  rateMode\n  currency {\n    code\n    id\n  }\n  createdAt\n  minFreelancerRate {\n    value\n  }\n  freelancerRate {\n    value\n  }\n  fullAddress\n  city\n  region\n  country\n  locationType\n  description\n  firm {\n    logoUrl\n    name\n    website\n    slug\n    id\n  }\n}\n\nfragment JobHeader_Job on Job {\n  title\n  incognito\n  jobStatus: status\n  jobApplication {\n    ...JobHeader_JobApplication\n    id\n  }\n  firm {\n    self\n    name\n    logoUrl\n    backgroundTheme\n    slug\n    id\n  }\n}\n\nfragment JobHeader_JobApplication on JobApplication {\n  status\n}\n\nfragment JobHeader_User on User {\n  status\n  ...user_useIsMember\n  ...user_useIsGuest\n  ...user_useIsClient\n}\n\nfragment JobPostingContent_Job on Job {\n  id\n  locationLatitude\n  locationLongitude\n  incognito\n  enableAutomatedMessaging\n  jobStatus: status\n  firm {\n    self\n    id\n  }\n  ...JobRatesFields_Job\n  ...OfficePolicyInfo_Job\n  ...JobShare_Job\n}\n\nfragment JobPosting_Job on Job {\n  ...JobPostingContent_Job\n  ...JobFormWrapper_Job\n  incognito\n}\n\nfragment JobRatesFields_Job on Job {\n  ...RateExplanation_Job\n}\n\nfragment JobShare_Job on Job {\n  slug\n  firm {\n    slug\n    id\n  }\n  referralFromSelf {\n    token\n    id\n  }\n}\n\nfragment Job_Job on Job {\n  slug\n  title\n  firm {\n    slug\n    name\n    id\n  }\n  contract {\n    status\n    id\n  }\n  ...JobHead_Job\n  ...JobHeader_Job\n  ...JobPosting_Job\n  ...JobClientActions_Job\n  ...JobFooter_Job\n  ...job_useApplyToJob\n}\n\nfragment Job_User on User {\n  status\n  workingOrOfferedJob\n  ...user_useIsMasked\n  ...user_useIsMember\n  ...user_useIsGuest\n  ...JobHeader_User\n  ...JobClientActions_User\n  ...JobFooter_User\n}\n\nfragment JobsListingItem_Job on Job {\n  title\n  slug\n  description\n  positionTypes\n  rateMode\n  clientRate {\n    value\n  }\n  minClientRate {\n    value\n  }\n  freelancerRate {\n    value\n  }\n  minFreelancerRate {\n    value\n  }\n  currency {\n    code\n    id\n  }\n  firm {\n    slug\n    name\n    id\n  }\n  jobSkills {\n    required\n    requiredYears\n    groupIndex\n    skill {\n      id\n      name\n    }\n    userSkill {\n      experience\n      id\n    }\n    id\n  }\n  jobApplication {\n    ...JobsListingItem_JobApplication\n    id\n  }\n  ...RateExplanation_Job\n  ...JobShare_Job\n}\n\nfragment JobsListingItem_JobApplication on JobApplication {\n  id\n  status\n  ...ApplicationStepsButton_JobApplication\n  ...ApplicationStatusTextTag_JobApplication\n  ...jobApplication_useIsUnsentJobApplication\n}\n\nfragment JobsListing_Firm on Firm {\n  id\n  self\n  backgroundTheme\n  name\n  description\n  slug\n  logoUrl\n  video {\n    id\n  }\n  jobs(first: 20, filters: {status: opened}) {\n    edges {\n      node {\n        id\n        ...JobsListingItem_Job\n      }\n    }\n  }\n}\n\nfragment JobsListing_User on User {\n  configuration {\n    enableCompanyVideos\n  }\n}\n\nfragment LocationFields_User on User {\n  profile {\n    locationBounds0\n    locationBounds1\n    locationBounds2\n    locationBounds3\n    locationLatitude\n    locationLongitude\n    fullAddress\n    id\n  }\n}\n\nfragment NameFields_User on User {\n  firstName\n  lastName\n}\n\nfragment OfficePolicyInfo_Job on Job {\n  officePolicy\n}\n\nfragment ProfileRateFields_User on User {\n  ...CompensationSummary_User\n  ...ExperienceSummary_User\n  ...RateEditDialog_User\n}\n\nfragment RateEditDialog_User on User {\n  profile {\n    freelancerRate {\n      value\n      currency {\n        code\n        id\n      }\n    }\n    jobTypes\n    rateMode\n    id\n  }\n}\n\nfragment RateExplanation_Job on Job {\n  positionTypes\n  minClientRate {\n    value\n  }\n  clientRate {\n    value\n  }\n  freelancerRate {\n    value\n  }\n  minFreelancerRate {\n    value\n  }\n  margin\n  minMarginUsd\n  rateMode\n  currency {\n    code\n    id\n  }\n}\n\nfragment SocialLinksEditDialog_User on User {\n  profile {\n    urlBlog\n    urlDribbble\n    urlGithub\n    urlLinkedin\n    id\n  }\n}\n\nfragment SocialLinksFields_User on User {\n  profile {\n    urlBlog\n    urlDribbble\n    urlGithub\n    urlLinkedin\n    id\n  }\n  resume {\n    url\n    id\n  }\n  ...SocialLinksEditDialog_User\n}\n\nfragment SpecializationFieldsDialog_User on User {\n  profile {\n    industry {\n      id\n    }\n    specializations {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment Specialization_Specialization on Specialization {\n  id\n  name\n}\n\nfragment SpecializationsFields_User on User {\n  profile {\n    industry {\n      id\n    }\n    specializations {\n      id\n      name\n      ...Specialization_Specialization\n    }\n    id\n  }\n  ...SpecializationFieldsDialog_User\n}\n\nfragment StatusField_User on User {\n  status\n}\n\nfragment Summary_UserProfile on User {\n  profile {\n    openToOpportunities\n    id\n  }\n  ...SpecializationsFields_User\n  ...TextIntroductionField_User\n  ...LocationFields_User\n  ...AvatarField_User\n  ...NameFields_User\n  ...IndustryField_User\n  ...SocialLinksFields_User\n  ...BadgesArea_User\n  ...ProfileRateFields_User\n}\n\nfragment TeamManagementField_User on User {\n  profile {\n    managedTeamSize\n    id\n  }\n}\n\nfragment TextIntroductionField_User on User {\n  profile {\n    textIntroduction\n    id\n  }\n}\n\nfragment TimelineEntriesField_TimelineEntries on TimelineEntry {\n  id\n  entryType\n  place\n  title\n  dateStart\n  dateEnd\n  description\n  institute {\n    worldRankRange\n    rankingYear\n    id\n  }\n  company {\n    custom\n    id\n  }\n  skills {\n    id\n    name\n  }\n}\n\nfragment TimelineEntriesField_User on User {\n  profile {\n    industry {\n      id\n    }\n    id\n  }\n  timelineEntries {\n    ...TimelineEntriesField_TimelineEntries\n    id\n  }\n}\n\nfragment USWorkField_User on User {\n  profile {\n    canWorkInTheUs\n    id\n  }\n}\n\nfragment UserSkillsEditDialog_User on User {\n  id\n  profile {\n    industry {\n      id\n      name\n    }\n    id\n  }\n  userSkills {\n    experience\n    skill {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment UserSkillsFields_User on User {\n  ...UserSkillsEditDialog_User\n  profile {\n    industry {\n      profilesRequireSkills\n      id\n    }\n    id\n  }\n  userSkills {\n    experience\n    skill {\n      id\n      name\n    }\n    id\n  }\n}\n\nfragment VideoAnswersField_User on User {\n  answers {\n    id\n    url\n    public\n    question {\n      rawId\n      title\n      id\n    }\n  }\n}\n\nfragment VideoField_User on User {\n  video {\n    id\n  }\n}\n\nfragment jobApplication_useIsUnsentJobApplication on JobApplication {\n  status\n  contract {\n    id\n  }\n}\n\nfragment job_useApplyToJob on Job {\n  id\n  firm {\n    contract {\n      id\n    }\n    id\n  }\n}\n\nfragment user_isClient on User {\n  status\n  isClient\n}\n\nfragment user_isGuest on User {\n  guest\n  status\n}\n\nfragment user_isMember on User {\n  status\n  isMember\n}\n\nfragment user_isRealAdmin on User {\n  roles\n  realUser {\n    roles\n    id\n  }\n}\n\nfragment user_isRecruiterOrAdmin on User {\n  roles\n  realUser {\n    roles\n    id\n  }\n}\n\nfragment user_useIsClient on User {\n  ...user_isClient\n}\n\nfragment user_useIsGuest on User {\n  ...user_isGuest\n}\n\nfragment user_useIsMasked on User {\n  id\n  realUser {\n    id\n  }\n}\n\nfragment user_useIsMember on User {\n  ...user_isMember\n}\n\nfragment user_useIsRealAdmin on User {\n  ...user_isRealAdmin\n}\n\nfragment user_useIsRecruiterOrAdmin on User {\n  ...user_isRecruiterOrAdmin\n}\n"
  }
};
})();

(node as any).hash = "b7436d8be3c894df7228b1196ecbc411";

export default node;
